/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StockTransferLineItemsDto as DigiworkMaitreDPosDtoInventoryStockTransferLineItemsStockTransferLineItemsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransferLineItems/stock-transfer-line-items-dto';
import { InventoryStockTransferDto as DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/inventory-stock-transfer-dto';

export interface ReceiveStockTransfer$Params {
  inventoryId: string;
  transferId: string;
      body?: DigiworkMaitreDPosDtoInventoryStockTransferLineItemsStockTransferLineItemsDto
}

export function receiveStockTransfer(http: HttpClient, rootUrl: string, params: ReceiveStockTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>> {
  const rb = new RequestBuilder(rootUrl, receiveStockTransfer.PATH, 'post');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.path('transferId', params.transferId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>;
    })
  );
}

receiveStockTransfer.PATH = '/api/inventories/{inventoryId}/transfers/{transferId}';
